<template>
  <v-row no-gutters :class="{ 'text--disabled': disabled }" justify="space-between">
    <v-col class="draggable-list-col">
      <v-row no-gutters class="pb-3" align="center" v-if="title || !disableGroupAdding">
        <v-col cols="auto" class="text-left" v-if="title">
          <span class="font-weight-medium">
            {{ title }}
          </span>
        </v-col>
        <template v-if="!disableGroupAdding">
          <v-spacer></v-spacer>
          <v-col cols="auto">
            <base-button :disabled="disabled" @click="$emit('addGroup')" :straight-text="addGroupTitle" class="mr-0" />
          </v-col>
        </template>
      </v-row>
      <v-row no-gutters>
        <v-col cols="12">
          <draggable-list-draggable
            :items="value"
            :allow-elements-on-main-level="allowElementsOnMainLevel"
            :allow-nested-groups="allowNestedGroups"
            :disabled="disabled"
            :elements-dots-items="elementsDotsItems"
            :groups-dots-items="groupsDotsItems"
            :item-title-key="itemTitleKey"
            :child-items-key="childItemsKey"
            v-on="$listeners"
          >
            <template v-for="(value, key) in $scopedSlots" #[key]="scope">
              <slot :name="key" v-bind="scope" />
            </template>
          </draggable-list-draggable>
        </v-col>
      </v-row>
    </v-col>
  </v-row>
</template>
<script>
import DraggableListDraggable from '@/components/DraggableListDraggable';
export default {
  name: 'DraggableList',
  components: { DraggableListDraggable },
  props: {
    addGroupPath: {
      type: String,
      default: 'button.addGroup',
    },
    addGroupStraight: {
      type: String,
      default: '',
    },
    allowElementsOnMainLevel: {
      type: Boolean,
      default: false,
    },
    allowNestedGroups: {
      // Prop 'allowNestedGroups' got some uix issues
      // and doesnt work quite well with default 'DraggableListItem' when dragging
      // Need to be fixed or use another component if needed to be used
      // Currently, left as a mock for this feature
      type: Boolean,
      default: false,
    },
    childItemsKey: {
      type: String,
      default: 'items',
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    disableGroupAdding: {
      type: Boolean,
      default: false,
    },
    elementsDotsItems: {
      type: Array,
    },
    groupsDotsItems: {
      type: Array,
    },
    itemTitleKey: {
      type: String,
      default: 'name',
    },
    titlePath: {
      type: String,
      default: '',
    },
    titleStraight: {
      type: String,
      default: '',
    },
    value: {
      type: Array,
      default: () => {
        return [];
      },
    },
  },
  computed: {
    addGroupTitle() {
      return this.addGroupStraight || this.$i18n.t(this.addGroupPath);
    },
    title() {
      return this.titleStraight || this.$i18n.t(this.titlePath);
    },
  },
};
</script>
<style scoped lang="scss">
.draggable-list-col {
  @include customColSize(48);
}
</style>
